'use strict'

export const SHOW_TOGGLE = 'SHOW_TOGGLE'
export const LAYOUT = 'LAYOUT'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js